<template>
  <div class="min-wt1200" :class="`${workbenchCurrentStepSup> 0 ? `active-workbench-step-item${workbenchCurrentStepSup}`:''}`">
    <div id="public-toolbar-new" style="position: relative;z-index: 999"/>
    <div>
      <div id="public-toolaside-new"/>
      <div class="workBench" :class="{'asideCollapse': isCollapse}">
        <div class="workBench-top mb15">
          <!-- 个人信息卡片 -->
          <person-info-card type="2" :personInfo="personInfo"></person-info-card>
        </div>
        <div class="workBench-cont clearfix">
          <div class="workBench-right">
            <!-- 联系我们 -->
            <relation-our></relation-our>
            <!-- 商机推荐 -->
            <business-recommend
                    :pushSupplierInfo="pushSupplierInfo"
                    :url="personInfo.companyUrl"
            ></business-recommend>
            <!-- 轮播图 -->
            <carousel :bannerInfo="personInfo.bannerInfoDto"></carousel>
            <!-- 平台公告 -->
            <platform-announcement
                    :noticeDtos="personInfo.noticeDtos"
            ></platform-announcement>
            <!-- 企业管理员 -->
            <business-management :orgManagerList="orgManagerList"></business-management>
            <!-- 操作指引 -->
            <opera-guideline :columnDtos="personInfo.columnDtos"></opera-guideline>
          </div>
          <div class="workBench-left">
            <!-- 状态类型卡片 -->
            <status-class-card class="mb15" :statusData="statusData"></status-class-card>
            <!-- 待办事项 -->
            <backlog-tab class="mb15"></backlog-tab>
            <!-- 项目tab -->
            <item-tab type="2" class="mb15"></item-tab>
          </div>
        </div>
        <!-- 底部版权 -->
        <!-- <footer-item></footer-item> -->
      </div>
        <!-- 底部版权 -->
      <div id="public-toolfooterlast" class="workbench-footer"></div>
    </div>
    <el-dialog
        width="360px"
        :visible="showTip"
        :show-close="false"
        custom-class="dialogReminder"
        center>
        <!-- <div style="margin:20px 0;text-align:center">亲爱的用户，您不小心访问了没有权限的页面，系统即将跳转到您的工作台。</div>
        <span slot="footer" class="tip-dialog-footer">
            <el-button
                type="primary"
                size="small"
                @click="tipDialogHandle">确认跳转</el-button>
        </span> -->

      <div class="reminderCon">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/expression_icon.png" alt="">
        <p class="title">您好，此页面仅提供给供应商哦</p>
        <p><span class="number">1</span>亲爱的用户，您不小心访问了没有权限的页面，请点击立即前往跳转到您的工作台。</p>
        <!-- <p><span class="number">2</span>如果您是采购商，我们有“安心采”服务，专门帮助采购商降低采购风险 &nbsp<a @click="$router.push('creditReport')" style="color: #3F88E0;text-decoration: none;cursor: pointer;">立即查看</a></p> -->
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="tipDialogHandle">立即前往</el-button>
        </span>
      </div>
    </el-dialog>

<!--    新手引导-->
    <novice-guidance-sup></novice-guidance-sup>
  </div>

</template>
<script>
import Cookies from "js-cookie";
import personInfoCard from "./components/personInfoCard.vue";
import statusClassCard from "./components/statusClassCard";
import itemTab from "./components/itemTab.vue";
import backlogTab from "./components/backlogTab.vue";
import businessRecommend from "./components/businessRecommend.vue";
import shortcutMenu from "./components/shortcutMenu.vue";
import platformAnnouncement from "./components/platformAnnouncement.vue";
import carousel from "./components/carousel.vue";
import businessManagement from "./components/businessManagement.vue";
import operaGuideline from "./components/operaGuideline.vue";
import footerItem from "./components/footerItem.vue";
import relationOur from "./components/relationOur.vue"
import noviceGuidanceSup from './components/noviceGuidanceSup.vue'

import { loadScript } from '@/assets/js/utils'
import { mapState } from 'vuex'

export default {
  props: [],
  data() {
    return {
      personInfo: {},
      // 推荐商机
      pushSupplierInfo: {},
      statusData:[],//卡片
      orgManagerList:[],//人员
      isCollapse: false,
      aside: null,
      showTip:false,//是否有权限
    };
  },
  components: {
    "person-info-card": personInfoCard,
    "status-class-card": statusClassCard,
    "item-tab": itemTab,
    "backlog-tab": backlogTab,
    "shortcut-menu": shortcutMenu,
    "business-recommend": businessRecommend,
    "platform-announcement": platformAnnouncement,
    "carousel": carousel,
    "business-management": businessManagement,
    "opera-guideline": operaGuideline,
    "footer-item": footerItem,
    "relation-our": relationOur,
    'novice-guidance-sup': noviceGuidanceSup
  },
  computed: mapState([
    'workbenchCurrentStepSup'
  ]),
  mounted() {
    // 获取当前展开状态
    this.$route.query.isCollapse == '1' && (this.isCollapse = true)
    loadScript('http://static.onelinkplus.com/p/onelink.arch.public.ui/v0.0.2/toolaside.js?version=3',() => {
      this.aside = new window.onelink.ToolAside("public-toolaside-new", { isCollapse: this.isCollapse });
    });

    loadScript('http://static.onelinkplus.com/p/onelink.arch.public.ui/v0.0.2/toolbarNew.js?version=3',() => {
      new window.onelink.ToolbarNew("public-toolbar-new", { isShowAside: true, asideId: "public-toolaside-new"}, this.toggleAsideCB);
    });
    loadScript('http://static.onelinkplus.com/p/onelink.arch.public.ui/v0.0.2/toolfooterlast.js?version=3',() => {
      new window.onelink.ToolfooterLast("public-toolfooterlast");
    });

    this.init()
  },
  methods: {
    tipDialogHandle(){
      // 10 供应商，20采购商
      if(Cookies.get("userTag")=='20'){
        this.$router.push('/purchaseWorkBench')
      }
        // this.$router.push('/supplierWorkBench')
    },
    async init() {
      if(Cookies.get("userTag")=='20'){
        this.showTip=true
      }else{
        this.showTip=false

        // 判断用户是否补全信息   未补全去补全 补全则弹出新手引导
        await this.$store.dispatch('findWebDtoHandler');
        this.$store.dispatch('informationCompletion', () => {
          if (this.getToken('isExperience') == 1) {
            this.$store.commit("changeWorkbenchStepSup", 1);
            let bodyHtml = document.querySelector('body');
            bodyHtml.style.overflowY = 'hidden';
          }
        });
      }
      // 人员信息
      this.findCardInfo()

      // 供应商端--数据汇总概览 所有的订单数量 所有的项目数量 所有的发货数量
      this.loadSupplierCollect()


      // 推荐商机
      this.pushSupplierBizProject()

      // 查询企业管理员
      this.selectOrgManager()
    },
    // 供应商端--数据汇总概览 所有的订单数量 所有的项目数量 所有的发货数量
    loadSupplierCollect() {
      this.$axios
        .get("/onelink.mdata.main.api/loadSupplierCollect", {
          params: {
            language: "zh_CN"
          }
        })
        .then(res => {
          // console.info(res)
          this.$set(this, 'statusData', res.data.rows)
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 人员信息
    findCardInfo() {
      this.$axios
        .post("/onelink.mdata.main.api/card/findCardInfo")
        .then(res => {
          // console.info(res.data.data);
          if (res.data.code == 0) {
            this.personInfo = res.data.data;
          } else {
            this.$message.error(res.data.errorMsg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 推荐商机
    pushSupplierBizProject() {
      this.$axios
        .post("/onelink.mdata.main.api/card/pushSupplierBizProject")
        .then(res => {
          // console.info(res.data.data)
          if (res.data.code == 0) {
            this.pushSupplierInfo = res.data.data
          } else {
            this.$message.error(res.data.errorMsg)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // POST 查询企业管理员
    selectOrgManager () {
      this.$axios
        .post(`/onelink.mdata.main.api/recruitInfo/selectOrgManager?orgId=${Cookies.get("justId")}`)
        .then(res => {
          // console.info(res.data.data);
          // if (res.data.code == 0) {
          //   this.orgManagerList = res.data;
          // } else {
          //   this.$message.error(res.data.errorMsg);
          // }
            this.orgManagerList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 切换菜单回调
    toggleAsideCB () {
      // this.aside.toggleMeunEvent()
      this.isCollapse = !this.isCollapse
    }
  }
};
</script>
<style lang="stylus">
  .workbench-footer{
    .co-public-toolfooterlast{
      background-color: #f0f2f5;
    }
    .co-public-toolfooterlast .toolfooter-copyright{
      border-top: 1px solid #dcdfe6;
    }
  }
  .co-public-toolbar-new .toolbar-container{
    z-index: 999 !important;
  }
.min-wt1200{
  min-width: 1200px;
}
.workBench {
  margin-left: 200px;
  margin-top: 60px;
  background: #f0f2f5;
  padding: 15px;
  &.asideCollapse{
    margin-left: 46px;
   }
}
.workBench .mb15 {
  margin-bottom: 15px;
}
.workBench-cont {
}
.workBench-left{

  padding-right:15px;
  margin-right 320px;
}
.workBench-right{
  float:right;
  width:320px;
}
</style>



// WEBPACK FOOTER //
// src/pages/workBench/supplierIndex.vue